<template>
    <div class="bi-table d-flex flex-column">
        <div class="bi-table_row" v-for="({ title, value, params }, index) in data" :key="index">
                    
            <div class="bi-table_label">{{ title }}</div>
            <div class="bi-table_value">
                <template v-if="$scopedSlots.value_params && params" class="natural-400">
                    <slot name="value_params" :data="{ title, value }"/>
                </template>
                <template v-else class="natural-400">{{ format_value(value) }}</template>
            </div>
            
        </div>
    </div>
</template>

<script>
export default
{
    props:
    {
        data: Array,
    },

	methods :
	{
		format_value(value)
		{
			if(typeof value == "boolean")
			{
				if(value)
					return "Да"

				return "Нет"
			}

			return value
		},
	},
}
</script>

<style scoped>
.bi-table
{
    gap: .5rem;
    width: 100%;
}
.bi-table_row
{
    display: flex;
    gap: 16px;
    width: 100%;
}
.bi-table_label
{
    width: 50%;
    text-align: end;
}
.bi-table_value
{
    width: 50%;
    color: var(--bft-neutral-400);
}
</style>
